exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2qd88rojz_FqLsxC3RSGkM{border-top:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._2zZKCdfmvSoJOe7TeniLZ1{padding:12px 0}", ""]);

// exports
exports.locals = {
	"sweepRuleRowsContainer": "_2qd88rojz_FqLsxC3RSGkM",
	"emptyRules": "_2zZKCdfmvSoJOe7TeniLZ1"
};